import { supabase } from '../supabase';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

if (!baseUrl) {
  throw new Error('VITE_API_BASE_URL es obligatoria. Revisa .env.');
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: unknown,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const headers = new Headers(init?.headers);
  headers.set('Accept', 'application/json');
  // Sprint 13 S13-16: FormData necesita que el browser autosetee
  // Content-Type con el boundary multipart. NO forzar application/json.
  const esFormData =
    typeof FormData !== 'undefined' && init?.body instanceof FormData;
  if (init?.body && !headers.has('Content-Type') && !esFormData) {
    headers.set('Content-Type', 'application/json');
  }
  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`);
  }

  const response = await fetch(`${baseUrl}${path}`, { ...init, headers });

  const text = await response.text();
  let body: unknown = null;
  if (text) {
    try {
      body = JSON.parse(text);
    } catch {
      body = text;
    }
  }

  if (!response.ok) {
    throw new ApiError(
      response.status,
      body,
      `API ${response.status} en ${init?.method ?? 'GET'} ${path}`,
    );
  }

  return body as T;
}
